






































































































import Ajax from '../../../lib/ajax'
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
import selectTree from '../../../components/selectTree/selectTree.vue'
import { createLogger } from 'vuex'
@Component({
  components: { selectTree },
})
export default class EditUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean

  user: User = new User()

  treeData = []
  created() {
    let _this = this
    setTimeout(() => {
      _this.getTree()
    }, 1000)
  }

  // 监听 departmentTree2 的变化
  @Watch('$store.state.department.departmentTree2', { immediate: true, deep: true })
  onDepartmentTree2Change(newValue: any, oldValue: any) {
    if (newValue !== oldValue) {
      this.getTree() // departmentTree2 发生变化时调用 getTree() 方法
    }
  }

  get selectValue() {
    return this.$store.state.user.selectInit
  }
  get roles() {
    return this.$store.state.user.roles
  }
  async getTree() {
    let respone = await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree')
    this.editeTreeValue(respone.data.result)
    this.treeData = respone.data.result
    this.$emit('postComponent', this)
  }
  organizationID() {
    this.user['organizationUnitIds'] = []
  }
  selectChange(data) {
    this.organizationID()
    this.user['organizationUnitIds'] = data
    console.log(this.user['organizationUnitIds'])
  }
  removeRoot(data) {
    this.user['organizationUnitIds'] = data
  }
  editeTreeValue(data) {
    for (let i = 0; i < data.length; i++) {
      data[i].title = data[i].displayName
      data[i].value = data[i].id
      if (data[i].children) {
        if (data[i].children.length > 0) {
          data[i].expand = true
        }
        this.editeTreeValue(data[i].children)
      }
    }
  }
  changeTimeBirth(e, date) {
    this.user['birthDate'] = e
  }
  changeTimeGradua(e, date) {
    this.user['graduationDate'] = e
  }
  changeTimeStartWork(e, date) {
    this.user['startWorkDate'] = e
  }
  changeTimeEnterUnit(e, date) {
    this.user['enterUnitDate'] = e
  }
  changeTimeJobEntry(e, date) {
    // this.user['joinedCompanyDate'] =new Date(e)
    this.user['joinedCompanyDate'] = e
  }
  changeTimeLeave(e, date) {
    this.user['leaveDate'] = e
  }
  save() {
    ;(this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let json = JSON.parse(JSON.stringify(this.user))
        json.organizationUnitIds = []
        json.organizationUnitIds = this.user['organizationUnitIds']
        await this.$store.dispatch({
          type: 'user/update',
          data: json,
        })
        ;(this.$refs.userForm as any).resetFields()
        this.$emit('save-success')
        this.$emit('input', false)
      }
    })
  }
  cancel() {
    ;(this.$refs.userForm as any).resetFields()
    this.$emit('input', false)
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value)
    } else {
      this.user = Util.extend(true, {}, this.$store.state.user.editUser)
    }
  }
  rerequiredOrgan = (rule: any, value: any, callback: any) => {
    // if (!this.user['organizationUnitIds'] || this.user['organizationUnitIds'].length==0) {
    if (value === '' || value === undefined || value === null) {
      callback(new Error('必填项不能为空'))
    } else {
      callback()
    }
  }
  requiredJoinedCompanyDate = (rule: any, value: any, callback: any) => {
    console.log(value, 'sss')
    // if (!this.user['organizationUnitIds'] || this.user['organizationUnitIds'].length==0) {
    // if (value === '' || value === undefined || value === null) {
    // 		callback(new Error('必填项不能为空'));
    // } else {
    // 	callback();
    // }
  }
  //判断请假日期
  validateDate = (rule, value, callback) => {
    if (value == '' || value === undefined || value === null) {
      callback(new Error('日期不能为空'))
    } else {
      callback()
    }
  }
  userRule = {
    // organizationUnitIds: [{ required: true, message: '必选项不能为空', trigger: 'blur,change', type: 'number' }],
    organizationUnitIds: [{ required: true, validator: this.rerequiredOrgan, trigger: 'change' }],
    userName: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    name: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    number: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    post: [{ required: true, message: '必选项不能为空', trigger: 'change', type: 'number' }],
    // workStatus: [{ required: true, message: '必选项不能为空', trigger: 'blur,change', type: 'number' }],
    emailAddress: [
      { required: true, message: '必填项不能为空', trigger: 'blur' },
      { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
    ],
    // joinedCompanyDate:[{required:true,message:'必填项不能为空',trigger: 'blur',type:'date'}],
    // joinedCompanyDate: [{ required: true, validator: this.requiredJoinedCompanyDate, trigger: 'change' }],
    joinedCompanyDate: [
      {
        required: true,
        pattern: /.+/,
        validator: this.validateDate,
        trigger: 'blur',
      },
    ],
  }
}
